module.exports = __webpack_public_path__ + "img/271.efe31f62.jpg";